import React, { useEffect } from "react";
import { useState } from "react";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { usePageDetail, usePageSave } from "../../../hooks/api/pages/hooks";
import { useMessageApi } from "../../../provider/AntdNotification";
import { getSingleImageUrl } from "../../../lib/utils";
import { useQueryState } from "nuqs";
import { Form } from "antd";
import Banner from "../../../views/components/sections/Banner";
import OurMissionVision from "./OurMissionVision";

const AboutTabs: React.FC<{
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [pageData, setPageData] = useState<any>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();

  const { data } = usePageDetail("ABOUT");
  const { mutate: updateService, isPending } = usePageSave({});
  const [editingRow, setEditingRow] = useState<string | null>(null);

  const sections = ["Banner", "Our Misson & Vision"];
  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      let payload: any = {
        _id: pageData?._id,
        pageType: "ABOUT",
        banner: pageData?.banner || {},
        our_mission_vision: pageData?.our_mission_vision || {},
      };

      if (values.banner) {
        payload.banner = {
          ...values.banner,
          image: getSingleImageUrl(values.banner?.image),
        };
      }

      if (values.our_mission_vision) {
        payload.our_mission_vision = {
          ...(pageData?.our_mission_vision || {}),
          ...(values.our_mission_vision || {}),
        };
      }

      updateService(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: (err) => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const handleCancel = () => {
    setIsEditing(false);
  };

  return (
    <div>
      <TabsContain
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
        sections={sections}
      />

      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.banner}
          loading={isPending}
        />
      )}
      {activeTab === "Our Misson & Vision" && (
        <OurMissionVision
          editingRow={editingRow}
          setEditingRow={setEditingRow}
          handleCancel={() => setEditingRow(null)}
          handleSave={handleSave}
          form={form}
          aboutData={pageData?.our_mission_vision}
          loading={isPending}
        />
      )}
    </div>
  );
};

export default AboutTabs;
